import config from "../config";

export const getFileUrl = (file?: string | null, size: number | null = 150) => {
  return `${config.file_url}/aws-s3/file/${file}${size ? `?size=${size}` : ''}`;
};

export const downloadFileFromUrl = (url: string, fileName: string) => {
  const a = document.createElement('a');
  a.href = url;
  a.target = '_blank';
  a.rel = 'noreferrer';
  a.download = fileName || 'download';

  document.body.appendChild(a);
  a.click();

  document.body.removeChild(a);
};
